import { addComponent, loadComponents, removeComponent } from '@app/actions';
import { IComponentsType } from '@app/app.interface';
import { AppState } from '@app/app.state';
import { Inject, Injectable } from '@rxdi/core';
import { Subscription } from 'rxjs';
import { interval } from 'rxjs';

@Injectable()
export class UIComponentsService {
  @Inject(AppState)
  private store: AppState;
  $components = this.store.select((state) => state.components);
  sub: Subscription;
  count = 0;

  subscribe() {
    this.unsubscribe();
    this.sub = interval(1000).subscribe(() => {
      this.addComponent({
        description: `
    An evolving set of free, open source web components for building mobile and desktop web
    applications in modern browsers.
    `,
        id: String(this.count++),
        items: 51,
        namespace: '2',
        owner: 'HTMLELements',
      });
    });
  }

  unsubscribe() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  updateComponents(component: IComponentsType) {
    this.removeComponent(component);
    this.addComponent(component);
  }

  loadComponents(components: IComponentsType[]) {
    this.store.dispatch(loadComponents(components));
  }

  addComponent(component: IComponentsType) {
    this.store.dispatch(addComponent(component));
  }

  removeComponent(component: IComponentsType) {
    this.store.dispatch(removeComponent({ id: component.id }));
  }
}
